import { DataSource, CollectionViewer } from '@angular/cdk/collections';
import { MatPaginator, MatSort } from '@angular/material';
import { map, catchError, finalize } from 'rxjs/operators';
import { Observable, of as observableOf, merge, BehaviorSubject, of } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ApiService } from '../../core/services/api.service';
import { OnInit } from '@angular/core';
import { DataRowOutlet } from '@angular/cdk/table';
import { isNumber } from 'util';

export class DataTableDataSource<T> extends DataSource<T>{
  private dataSubject = new BehaviorSubject<T[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private counterSubject = new BehaviorSubject<number>(10);

  public loading$ = this.loadingSubject.asObservable();
  public counter = this.counterSubject.asObservable();

  constructor(private apiService: ApiService, private endpoint: string) {
    super();
  }

  connect(collectionViewer: CollectionViewer): Observable<T[]> {
    return this.dataSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.dataSubject.complete();
    this.loadingSubject.complete();
  }

  loadData(filter: string = "",
    sortDirection: string = "asc", sortColumn: string = "", pageIndex: number = 0, pageSize: number = 10,
    extraParams: any) {
    this.loadingSubject.next(true);
    let params: HttpParams = new HttpParams();
    params = params.append("search", filter);
    params = params.append("sortDirection", sortDirection);
    params = params.append("sortColumn", sortColumn);
    params = params.append("page", pageIndex.toString());
    params = params.append("pageSize", pageSize.toString());

    if (extraParams && extraParams instanceof Object) {
      let value;
      for (let key in extraParams) {
        if (extraParams[key] instanceof Date) {
          value = extraParams[key].toISOString();
        } else {
          value = extraParams[key];
        }
        if (isNumber(value)) {
          if(!isNaN(value)){
            params = params.append(key, value.toString());
          }
        }
        else {
          if (value) {
            params = params.append(key, value);
          }
        }
      }
    }

    this.apiService.get(this.endpoint, params).pipe(
      catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    ).subscribe(response => {
      this.dataSubject.next(response.data.items);
      this.counterSubject.next(response.data.totalElements);
    });
  }
}
